module.exports = __webpack_public_path__ + "static/w4m-vid-02af5f0e0a8e0f23ec4866fdfd0f1165.mp4";